export const getFiles = (state) => state.getIn(['entities', 'file', 'files']);
